import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CopyableText from "components/common/CopyableText";
import React from "react";
import apiClient from "utils/apiClient";
import { Button, Modal, Spinner } from "react-bootstrap";


const FEELING_OPTIONS = [
  { key: "LIKE", label: "👍 LIKE" },
  { key: "DISLIKE", label: "👎 DISLIKE" },
  { key: "HAPPY", label: "😊 HAPPY" },
  { key: "SAD", label: "😔 SAD" },
];

const FEELING_MAP = FEELING_OPTIONS.reduce((acc, item) => {
  acc[item.key] = item.label;
  return acc;
}, {});

export default function ViewFeedbackModal({
  show,
  onClose,
  feedback,
  loading,
}) {
  const renderFeeling = (value) => {
    const label = FEELING_MAP[value] || value || "—";
    const style = {
      backgroundColor: value ? "#e8f7e3" : "#fbe9e7",
      color: value ? "#2e7d32" : "#c62828",
      padding: "3px 8px",
      borderRadius: "6px",
      fontSize: "0.75rem",
      border: value ? "1px solid #d5ebd0" : "1px solid #f5c6cb",
      fontWeight: 600,
      display: "inline-block",
    };
    return <span style={style}>{label}</span>;
  };

  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [isFetchingLink, setIsFetchingLink] = React.useState(false);

  const handlePreview = async (fileId) => {
  try {
    setIsFetchingLink(true);
    const url = `/storage-service/api/v1/files/photo/signed-urls?fids=${fileId}`;
    const response = await apiClient.get(url);

    const signedUrls = response.data; 

    if (signedUrls && signedUrls.length > 0) {
    
      setPreviewUrl(signedUrls[0]);
    } else {
      throw new Error("No signed URL returned");
    }
  } catch (error) {
    console.error("Storage Error:", error);
    alert("Could not load image preview.");
  } finally {
    setIsFetchingLink(false);
  }
};

  return (
    <>
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="modal-small-text"
      backdrop="static"
      keyboard
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Feedback Details
      </Modal.Header>

      <Modal.Body style={{ fontSize: "0.85rem" }}>
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: 120 }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : feedback ? (
          <div className="d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-1">
              <div>
                <strong>User:</strong> <CopyableText value={feedback.userId} />
              </div>
              <div>
                <strong>Subject:</strong> {feedback.subject || "No description"}
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <strong>Feeling:</strong> {renderFeeling(feedback.feeling)}
            </div>

            <div>
              <strong>Content:</strong>
              <p className="mb-0">
                {feedback.content || "No content provided"}
              </p>
            </div>

          <div>
                <strong>Content:</strong>
                <p className="mb-0">
                  {feedback.content || "No content provided"}
                </p>
              </div>

              <div>
                <strong>Attachments:</strong>
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {feedback.attachments && feedback.attachments.length > 0 ? (
                    feedback.attachments.map((fileId, index) => (
                      <button
                        key={fileId}
                        type="button"
                        disabled={isFetchingLink}
                        onClick={() => handlePreview(fileId)}
                        className="btn btn-sm btn-outline-success d-flex align-items-center gap-2"
                      >
                        {isFetchingLink ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <FontAwesomeIcon icon="paperclip" />
                        )}
                        <span>View Attachment {index + 1}</span>
                      </button>
                    ))
                  ) : (
                    <span className="text-muted ms-2" style={{ fontSize: '0.8rem' }}>
                      No files attached
                    </span>
                  )}
                </div>
              </div>
          </div>  
        ) : (
          <p>No data available</p>
        )}
      </Modal.Body>

      <div className="p-3 d-flex justify-content-end">
        <Button size="sm" variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>

      <Modal 
        show={!!previewUrl} 
        onHide={() => setPreviewUrl(null)} 
        centered 
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '14px' }}>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-0">
          {previewUrl && (
            <img 
              src={previewUrl} 
              alt="Attachment Preview" 
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} 
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setPreviewUrl(null)}>
            Close
          </Button>
          <a href={previewUrl} download className="btn btn-sm btn-success">
            Download Image
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
}
